import { Box, SelectChangeEvent } from '@mui/material';
import dayjs, { Dayjs } from 'dayjs';
import { useState, type ComponentType, type JSX } from 'react';

import { StyleObj } from '../../../@types';
import { BonusCampaignType } from '../../../@types/api';
import { BONUS_CAMPAIGN_TYPE } from '../../../constants/enums';
import BonusTypeSelect from '../../molecules/BonusTypeSelect';
import CollapsibleFilters from '../../molecules/CollapsibleFilters';
import DateRangeSelect from '../../molecules/DateRangeSelect';
import CashbackBonusReportsPage from './CashbackBonusReportsPage';
import NumberOfSelectionsBonusReportsPage from './NumberOfSelectionsBonusReportsPage';
import WelcomeBonusReportsPage from './WelcomeBonusReportsPage';

const styles: StyleObj = {
  container: {
    position: 'relative',
    height: 'calc(100% - 200px)',
  },
};

type BonusReportPageProps = {
  date: { fromTimestamp: Dayjs; toTimestamp: Dayjs };
  headerContent: JSX.Element;
};

const BONUS_REPORT_PAGES: Record<BonusCampaignType, ComponentType<BonusReportPageProps>> = {
  [BONUS_CAMPAIGN_TYPE.CASHBACK]: CashbackBonusReportsPage,
  [BONUS_CAMPAIGN_TYPE.NUM_OF_SELECTIONS]: NumberOfSelectionsBonusReportsPage,
  [BONUS_CAMPAIGN_TYPE.WELCOME_BONUS]: WelcomeBonusReportsPage,
};

const BonusReportsPage = () => {
  const [bonusType, setBonusType] = useState<BonusCampaignType>(BONUS_CAMPAIGN_TYPE.CASHBACK);
  const [date, setDate] = useState<{ fromTimestamp: Dayjs; toTimestamp: Dayjs }>({
    fromTimestamp: dayjs().startOf('day'),
    toTimestamp: dayjs().endOf('day'),
  });

  const handleBonusTypeChange = (event: SelectChangeEvent<BonusCampaignType>) => {
    setBonusType(event.target.value as BonusCampaignType);
  };

  const headerContent = (
    <CollapsibleFilters>
      <BonusTypeSelect value={bonusType} onChange={handleBonusTypeChange} />
      <DateRangeSelect date={date} onDateChange={setDate} />
    </CollapsibleFilters>
  );
  const SelectedBonusReportsPage = BONUS_REPORT_PAGES[bonusType];

  return (
    <Box sx={styles.container}>
      <SelectedBonusReportsPage date={date} headerContent={headerContent} />
    </Box>
  );
};

export default BonusReportsPage;
